import React from 'react'
import {Button, Form, Input, message, PageHeader, Row, Spin, Typography} from 'antd'
import {userDeactivate} from '../../api/user'
import Modal from 'antd/es/modal/Modal'
import {connect} from "react-redux";
import {URL_CANCEL_ACCOUNT, URL_LOGIN, URL_SIGNUP} from "../../const";
import {userLogout} from '../../action/user'
import {withRouter} from "react-router";
import {IN_PRODUCT} from "../../config/product";
import {submitCancelAccountHubspotForm, submitSignUpHubspotForm} from "../../api/hubspot";

const {Title} = Typography

@connect((state) => ({
        //decorator, gives component access to the state
        userId: state.user.info.userId,
        email: state.user.info.email
    }),
    {
        userLogout
    })
class CancelAccount extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            isP1ModalVisible: false,
            isP2ModalVisible: false,
            isP3ModalVisible: false,
            feedback: ""
        }

        this.formRef = React.createRef()

        this.showDeactivateModalP1 = () => {
            this.setState({
                isP1ModalVisible: true,
                isP2ModalVisible: false,
                isP3ModalVisible: false
            })
        }

        this.deactivateModalP1OK = () => {
            this.setState({
                isP1ModalVisible: false,
                isP2ModalVisible: true,
                isP3ModalVisible: false
            })
        }

        this.deactivateModalP1Cancel = () => {
            this.setState({
                isP1ModalVisible: false,
                isP2ModalVisible: false,
                isP3ModalVisible: false
            })
        }

        this.deactivateModalP2OK = () => {
            this.setState({
                isP1ModalVisible: false,
                isP2ModalVisible: false,
                isP3ModalVisible: true
            })
        }

        this.deactivateModalP2Cancel = () => {
            this.setState({
                isP1ModalVisible: false,
                isP2ModalVisible: false,
                isP3ModalVisible: false
            })
        }

        this.deactivateModalP3OK = async () => {
            try {
                if (IN_PRODUCT) {
                    await submitCancelAccountHubspotForm(
                        'eddb8230-af3b-4c57-92fb-6edad341b693',
                        [
                            {
                                objectTypeId: '0-1',
                                name: 'email',
                                value: this.props.email
                            },
                            {
                                objectTypeId: '0-1',
                                name: 'message',
                                value: this.state.feedback
                            }
                        ],
                        URL_CANCEL_ACCOUNT,
                        'SAM Cancel Account'
                    )
                }
            } catch (e) {
                console.log(e)
            }

            userDeactivate(this.props.userId)
                .then((response) => {
                    this.props.userLogout()
                    this.props.history.replace({pathname: URL_LOGIN})
                })
                .catch((error) => {
                    message.error(error.message).then((r) => {
                    })
                })
                .finally(() => {
                    this.setState({
                        isP1ModalVisible: false,
                        isP2ModalVisible: false,
                        isP3ModalVisible: false
                    })
                })
        }

        this.deactivateModalP3Cancel = () => {
            this.setState({
                isP1ModalVisible: false,
                isP2ModalVisible: false,
                isP3ModalVisible: false
            })
        }
        this.hb_script = document.createElement('script');

    }

    componentDidMount() {
        if (IN_PRODUCT) {
            this.hb_script.src = "//js.hs-scripts.com/7839862.js";
            this.hb_script.async = true;
            document.body.appendChild(this.hb_script);
        }
    }

    componentWillUnmount() {
        if (IN_PRODUCT) {
            document.body.removeChild(this.hb_script)
        }
    }

    render() {
        return (
            <Spin size='large' spinning={this.state.loading}>
                <PageHeader title={<Title>We&apos;re sorry to see you go.</Title>}/>
                <b>If there is anything we can do better, we would greatly appreciate your feedback.</b>
                <br/>
                <Form name={'cancel_account_form'} onFinish={(value)=>{
                    this.setState({
                        feedback: value['feedback']
                    })
                    message.info("feedback received").then(r => {})
                }}>
                    <Form.Item
                        rules={[
                            {
                                required: false,
                                type: 'string',
                                max: 20480,
                                min: 1
                            }
                        ]}
                        name={'feedback'}
                        label='Feedback'
                        wrapperCol={{span: 24}}
                        labelCol={{span: 0}}
                    >
                        <Input.TextArea autoSize={{minRows: 4}}/>
                    </Form.Item>
                        <Button type='primary' htmlType='submit'>Submit</Button>
                </Form>
                <br></br>
                <b>If you choose to cancel your account</b>
                <ul>
                    <li>Your profile will be removed.</li>
                    <li>Your artwork will be removed.</li>
                    <li>Your records of agreements, orders and payments will be removed</li>
                    <li>The agreements you made with the client or RevArt will remain in effect despite the
                        cancellation.
                    </li>
                    <li>You cannot claim your payment anymore.</li>
                </ul>
                <br/>

                <b>You can deactivate your account if you simply want to take a break from your artistic career.</b>
                <ul>
                    <li>Your profile and artworks will not be made visible to the general public.</li>
                    <li>You can still access your profile, artworks, records, and documents.</li>
                    <li>You can still claim your payment.</li>
                </ul>
                <br/>

                <Modal
                    title='Are you sure you want to terminate your account?'
                    visible={this.state.isP1ModalVisible}
                    onOk={this.deactivateModalP1OK}
                    onCancel={this.deactivateModalP1Cancel}
                    okText='Continue'
                    cancelText='Cancel'
                >
                    <p>
                        Before you deactivate your account, make sure you&apos;ve claimed all of your income. You will
                        not be able to claim your payment
                        later because the termination is irreversible.
                    </p>
                </Modal>
                <Modal
                    title='Are you sure you want to terminate your account?'
                    visible={this.state.isP2ModalVisible}
                    onOk={this.deactivateModalP2OK}
                    onCancel={this.deactivateModalP2Cancel}
                    okText='Continue'
                    cancelText='Cancel'
                >
                    <p>The picture uploaded will also be deleted.</p>
                </Modal>
                <Modal
                    title='Are you sure you want to terminate your account?'
                    visible={this.state.isP3ModalVisible}
                    onOk={this.deactivateModalP3OK}
                    onCancel={this.deactivateModalP3Cancel}
                    okText='Deactivate'
                    cancelText='Cancel'
                    okType='danger'
                >
                    <p>The termination of your account has no effect on the agreements you signed with RevArt or its
                        clients.</p>
                </Modal>
                <Row>
                    <Button danger style={{float: 'right', marginRight: '24px'}} onClick={this.showDeactivateModalP1}>
                        Deactivate
                    </Button>
                    <Button danger style={{float: 'left', marginRight: '24px'}}>
                        Cancel
                    </Button>
                </Row>
            </Spin>
        )
    }
}

export default withRouter(CancelAccount)
